export default "__VITE_ASSET__Dy4Q6ge0__"